"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var LinearProgress_1 = __importDefault(require("@material-ui/core/LinearProgress"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Icon_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/icon/Icon"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var styles_2 = __importDefault(require("./styles"));
var PasswordStrengthIndicator = function (_a) {
    var _b, _c;
    var password = _a.password, passwordErrors = _a.passwordErrors;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    if (!password || password.length === 0) {
        return null;
    }
    var passMinLength = !passwordErrors.includes('min');
    var passCase = !passwordErrors.includes('lowercase') && !passwordErrors.includes('uppercase');
    var passSpecialChar = !passwordErrors.includes('symbols') && !passwordErrors.includes('digits');
    var strengthText;
    var strength;
    if (passwordErrors.length <= 0 ||
        (passwordErrors.length === 1 && passwordErrors.includes('max'))) {
        strengthText = 'Strong';
        strength = 100;
    }
    else if (passwordErrors.length <= 2 && passwordErrors.length > 0) {
        strengthText = 'Medium';
        strength = 65;
    }
    else {
        strengthText = 'Low';
        strength = 35;
    }
    var passwordErrorMessages = [
        {
            pass: passMinLength,
            text: "Minimum of 8 characters."
        },
        {
            pass: passCase,
            text: "At least one lower and upper case alphabet."
        },
        {
            pass: passSpecialChar,
            text: "At least one number and one special character."
        }
    ];
    var unCheckIcon = (react_1.default.createElement(Icon_1.default, { iconName: "remove", iconType: "material", "aria-label": "Condition not met", color: "error" }));
    var checkIcon = (react_1.default.createElement(Icon_1.default, { iconName: "check", iconType: "material", "aria-label": "Condition met", className: classes.errorCheckbox }));
    return (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, container: true },
        react_1.default.createElement(Grid_1.default, { item: true, container: true, xs: 12, alignItems: "center", className: classes.header },
            react_1.default.createElement(Typography_1.default, { variant: "body2" }, "Password Strength:"),
            react_1.default.createElement(Typography_1.default, { variant: "body2", className: classes.strength },
                "\u00A0",
                strengthText)),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, alignItems: "center", className: classes.header },
            react_1.default.createElement(LinearProgress_1.default, { variant: "determinate", value: strength, style: { flex: 1, width: '100%' }, classes: {
                    barColorPrimary: (0, classnames_1.default)((_b = {},
                        _b[classes.weak] = passwordErrors.length > 2,
                        _b[classes.medium] = passwordErrors.length <= 2 && passwordErrors.length > 0,
                        _b[classes.strong] = passwordErrors.length === 0,
                        _b)),
                    colorPrimary: (0, classnames_1.default)((_c = {},
                        _c[classes.weakBar] = passwordErrors.length > 2,
                        _c[classes.mediumBar] = passwordErrors.length <= 2 && passwordErrors.length > 0,
                        _c[classes.strongBar] = passwordErrors.length === 0,
                        _c))
                } })),
        passwordErrorMessages.map(function (passwordErrorMessage) { return (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, alignItems: "center", key: passwordErrorMessage.text },
            passwordErrorMessage.pass ? checkIcon : unCheckIcon,
            react_1.default.createElement(Typography_1.default, { color: "textSecondary", variant: "caption" },
                react_1.default.createElement("span", { "aria-hidden": "true" }, passwordErrorMessage.text),
                react_1.default.createElement("span", { className: classes.visuallyHidden }, "Condition ".concat(passwordErrorMessage.pass ? 'met' : 'not met', ": ").concat(passwordErrorMessage.text))))); })));
};
exports.default = PasswordStrengthIndicator;
//# sourceMappingURL=PasswordStrengthIndicator.js.map